import { AmountCode } from 'typings/enums';

interface IAmountCodeDisplayOrdinal {
    [key: string]: number;
}

export const AmountCodeDisplayOrdinal: IAmountCodeDisplayOrdinal = {
    [AmountCode.Merit]: 1,
    [AmountCode.Bonus]: 2,
    [AmountCode.LumpSum]: 3,
    [AmountCode.MarketAdjustment]: 4,
    [AmountCode.VariablePay]: 5
};